import * as React from "react"
import { Animate, AnimateGroup } from "react-simple-animate"
import { navigate } from "@reach/router"
import Bday from "./Bday"
// @ts-ignore
import home from "../data/home"
import { useStateMachine } from "little-state-machine"
import translateLink from "./logic/translateLink"
import typographyStyles from "../styles/typography.module.css"
import buttonStyles from "../styles/button.module.css"
import styles from "./Header.module.css"
import logo from "../images/logo.png"

export default function Header({
  homeRef,
  defaultLang,
}: // isCardPlay,
{
  homeRef: React.Ref<HTMLDivElement>
  defaultLang: string
  // isCardPlay: boolean
}) {
  const [isWeb, setIsWeb] = React.useState(true)
  const {
    state: { language },
  } = useStateMachine()
  const {
    state
  } = useStateMachine()
  const { currentLanguage } =
    language && language.currentLanguage
      ? language
      : { currentLanguage: defaultLang }
  const lightMode = state?.setting?.lightMode

  return (
    <>
      <AnimateGroup play>
        <header className={styles.head} id="main">
          <Animate
            sequenceIndex={0}
            duration={0.2}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <img
                src={logo}
                className={styles.logo} style={style}
                alt="Create Next App"
              />
            )}
          />

          <Animate
            sequenceIndex={0}
            duration={0.2}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <h1
                className={`${typographyStyles.heading} ${styles.logoHeading}`}
                style={style}
              >
                Create Next App
              </h1>
            )}
          />

          <Animate
            sequenceIndex={1}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <p
                className={typographyStyles.subHeading}
                style={{ marginBottom: 0, maxWidth: 660, ...style }}
              >
                {home.slogan[currentLanguage]}
              </p>
            )}
          />

          <Animate
            sequenceIndex={2}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <div
                style={{
                  ...style,
                  minWidth: 300,
                  textAlign: 'center',
                }}
              >
                <button
                  className={buttonStyles.primaryButton}
                  onClick={() => {
                    // navigate(translateLink("get-started", currentLanguage))
                    let url = location.href
                    location.href = "#installation"
                    history.replaceState(null, null, url)
                  }}
                >
                  {home.getStarted[currentLanguage]} &nbsp;<span>▶</span>
                </button>
              </div>
            )}
          />
        </header>

        {/* <h4 className={styles.videoHeading}>React Web</h4>
        <div
          className={isWeb ? styles.videoWrapperShow : styles.videoWrapperHide}
        >
          <div style={{ position: "relative" }}>
            <Animate
              sequenceIndex={3}
              delay={0.1}
              start={{ opacity: 0 }}
              end={{ opacity: 1 }}
              duration={0.4}
              easeType="ease-in"
              render={({ style }) => (
                <video
                  className={styles.video}
                  id="tabPanel-1"
                  aria-labelledby="tabPanel-1"
                  controls
                  playsInline
                  muted
                  style={style}
                >
                  <source src={video} type="video/mp4" />
                </video>
              )}
            />
          </div>
        </div>

        <div
          className={isWeb ? styles.videoWrapperHide : styles.videoWrapperShow}
        >
          <h4 className={styles.videoHeading}>React Native</h4>
          <video
            className={styles.video}
            id="tabPanel-2"
            aria-labelledby="tabPanel-2"
            controls
            playsInline
            muted
          >
            <source src={nativeVideo} type="video/mp4" />
          </video>
        </div> */}

        {/* <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            className={styles.toggleGroup}
            role="tablist"
            aria-label="Select video"
          >
            <button
              aria-label="show web video"
              aria-selected={isWeb ? "true" : "false"}
              aria-controls="tabPanel-1"
              role="tab"
              disabled={isWeb}
              onClick={() => {
                setIsWeb(true)
              }}
            >
              React Web
            </button>
            <button
              disabled={!isWeb}
              role="tab"
              aria-label="show react native video"
              aria-selected={!isWeb}
              aria-controls="tabPanel-2"
              onClick={() => {
                setIsWeb(false)
              }}
            >
              React Native
            </button>
          </div>
        </div> */}
      </AnimateGroup>

      {/*<Bday isCardPlay={isCardPlay} />*/}
    </>
  )
}
